import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const a = "auth_token";
class r extends s {
  /**
   * Fetches an authentication token from the API.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/auth_token`
   *
   * @param {Record<string, any>} headers - (Optional) Custom HTTP headers to include in the request.
   * @returns {Promise<AuthTokenReceivedData>} A promise resolving to the data containing the authentication token.
   */
  getAuthToken = async (t = {}) => {
    const { data: e } = await this.get(
      `${a}`,
      {},
      t
    );
    return e;
  };
}
export {
  r as AuthToken
};
